import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {
    IEntityWithIDTranslations,
    IEntityWithTranslations,
    IErrorResponse,
    IRootState
} from "../../../../../../../types";
import {deletedLocation, deletedRestoreLocation,setLocation, setLocationRestore, updateLocation} from "./locationDetailsSlice";


const GetLocation = createAsyncThunk(
    "get/location",
    async (_, { dispatch,rejectWithValue,getState }) => {
        try {
            const response = await request.get("/student-location");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage

            dispatch(setLocation({data:response.data,defaultLanguage}));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const SetLocation = createAsyncThunk(
    "set/location",
    async (data: IEntityWithTranslations, { rejectWithValue }) => {
        try {
            const response = await request.post("/student-location", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteLocation = createAsyncThunk(
    "delete/location",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/student-location/${id}`);

            dispatch(deletedLocation(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditLocation = createAsyncThunk(
    "edit/location",
    async (data: IEntityWithIDTranslations, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/student-location/${data.id}`, data);
            dispatch(updateLocation(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetDeleteLocation = createAsyncThunk(
    "get/delete/location",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/student-location/deleted-items`);

            dispatch(setLocationRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const RestoreDeleteLocation= createAsyncThunk(
    "restore/delete/location",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/student-location/restore/${id}`);
            dispatch(deletedRestoreLocation(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export {
    GetLocation,
    SetLocation,
    DeleteLocation,
    EditLocation,
    GetDeleteLocation,
    RestoreDeleteLocation
};
